import { ACTION_CREATE, ACTION_EDIT } from '../../request';
import { Voter } from '../voter';

export class MessengersVoter extends Voter {
    supports(request) {
        return request.role === 'basic' && request.resource === 'messengers' && this.supportsVersion(request, '>=2.11');
    }

    vote(request) {
        if (request.includes(ACTION_CREATE)) {
            if (!this.canCreate(request)) {
                return false;
            }
        }

        if (request.includes(ACTION_EDIT)) {
            if (!this.canEdit(request)) {
                return false;
            }
        }

        return true;
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canCreate(request) {
        // can check for enabled messengers count instead,
        // but creation of already existing messenger should rise 'Already exists' error,
        // not 'Access forbidden' error
        return this.canEdit(request);
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canEdit(request) {
        if (!request.subject) {
            return true;
        }

        const {
            user: { workspace },
            subject,
        } = request;
        const enabled = workspace.card.messengers.find((m) => m.enabled);

        return !(enabled && enabled.messenger !== subject.messenger);
    }
}
